import React from 'react';
import {Link} from 'react-router-dom';
import {Button, Alert} from "reactstrap";
import {Card, CardContent} from "@material-ui/core";
import {Collections, Objects} from "components"
import Framework from "@beardeddevops/react.framework";
import APPCONFIG from "../../constants/Config";
import {confirmAlert} from "react-confirm-alert";
import Print, {PrintReceiptModal} from "../../containers/Print";
import ReceiptObject from "../Objects/Receipt"
import API from "@beardeddevops/react.api";
import Types from "../../constants/Types";
import {size} from "lodash";
import {toast} from "react-toastify";

const breadcrumbsStatic = [
	{
		name: 'Checkout',
		url: '/',
		icon: 'calculator',
	},
	{
		name: 'Transactions',
		url: '/transactions',
		icon: 'shopping-cart',
	}
];

class TransactionsView extends React.Component {

	constructor(props) {
		super(props);

		//Create a reference variable
		this.transactionRef = React.createRef();
		this.transactionEntriesRef = React.createRef();
		this.state = {
			Tkey: Math.random(),
			Rkey: Math.random(),
			modalRefund: false,
			refundItems: [],
			txInvoiceAmount: "0.00",
			txInvoiceRemaining: null,
			hasInvoice: false,
		}
	}

	componentDidUpdate() {
		const tx = this.transactionRef.current;
		if (!tx || !tx.state || !tx.state.pkey) {
			return;
		}
		const invoiceAmount = tx.state.invoice_amount || "0.00";
		const invoiceRemaining = tx.state.invoice_remaining;
		if (invoiceAmount !== this.state.txInvoiceAmount
			|| invoiceRemaining !== this.state.txInvoiceRemaining) {
			this.setState({
				txInvoiceAmount: invoiceAmount,
				txInvoiceRemaining: invoiceRemaining,
			});
		}
	}

	invoiceAmountDue() {
		const hasInvoiceStatus = this.state.txInvoiceRemaining != null && this.state.txInvoiceRemaining !== '';
		if (hasInvoiceStatus) {
			return parseFloat(this.state.txInvoiceRemaining || 0);
		}

		return parseFloat(this.state.txInvoiceAmount || 0);
	}

	handleSendInvoice = () => {
		const {current} = this.transactionRef;
		if (current && typeof current.sendInvoice === 'function') {
			current.sendInvoice();
		}
	};

	handleInvoiceMeta = (meta) => {
		if (meta == null) {
			return;
		}
		const invoiceAmount = parseFloat(meta.invoice_amount ?? 0);
		const invoiceRemaining = meta.invoice_remaining;
		const hasInvoiceStatus = meta.invoice_status != null && meta.invoice_status !== '';
		const hasInvoice = hasInvoiceStatus || invoiceAmount > 0.005;
		this.setState({
			hasInvoice,
			txInvoiceAmount: meta.invoice_amount ?? this.state.txInvoiceAmount,
			txInvoiceRemaining: invoiceRemaining,
		});
	}

	handleSendReceipt = async () => {
		let {current} = this.transactionRef;
		current.sendReceipt.call({current}, null);
	};

	handleRefund = async () => {
		await this.setState({Rkey: Math.random(), Tkey: Math.random()})
	}

	handleDelete = () => {
		let model = new API.BuildClass(Types.Transactions._name, API.RequestType.DELETE);
		model.object.pkey = this.props.transaction
		confirmAlert({
			title: 'Confirm Delete',
			message: `This will delete anything tied to this transaction ( Products, Refunds, and Certificates). Are you sure you want to delete this?`,
			buttons: [
				{
					label: 'Yes',
					onClick: async () => {
						try {
							await model.submit(null, API.RequestType.DELETE);
							this.props.history.push('/transactions');

						} catch (error) {
							console.error(error);
						}
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	}

	handlePrintReceipt = async () => {
		//load receiptData
		let rModel = new API.BuildClass(Types.Accounts_Customizations._name, API.RequestType.READ_ALL);
		let rData = await rModel.submit(null, API.RequestType.READ_ALL)
		this.setState({rModel: rData.rModel});

		//getting transaction data
		let tModel = new API.BuildClass(Types.Transactions._name, API.RequestType.READ);
		tModel.object.pkey = this.props.id;
		tModel.parent = this.props.id;
		let tData = await tModel.submit(null, API.RequestType.READ);

		let props = this.props;

		//load transactionData
		let data = this.transactionEntriesRef.current.state.data;
		let receiptData = this.transactionRef.current.state;
		let items = this.state.refundItems;

		confirmAlert({
			customUI: ({onClose}) => {
				return (
					<PrintReceiptModal
						onClose={onClose}
						account={this.props.rootState.account}
						data={data}
						rData={rData}
						receiptData={receiptData}
						items={items}
						props={props}
						transactionData={tData}
					/>
				);
			},
		});
	};

	/** Merchandise lines that still have quantity left to refund (excludes trade-ins). */
	refundableLineItems() {
		const list = this.state.refundItems || [];
		return list.filter((item) => {
			if (item.refunded === 1 || item.refunded === true) {
				return false;
			}
			if (item.transaction_type === "transaction_trade") {
				return false;
			}
			if (item.transaction_type === "transaction_product") {
				return item.refunded !== 1;
			}
			const saleQty = Math.max(1, parseInt(item.quantity, 10) || 1);
			const rq = parseInt(item.refund_quantity, 10);
			const refundedQty = Number.isFinite(rq) ? rq : 0;
			return saleQty > refundedQty;
		});
	}

	toggleRefund = () => {
		if (this.state.modalRefund === false) {
			if (size(this.refundableLineItems()) === 0) {
				API.ToastId = toast.error("There are no items available to refund", {
					position: toast.POSITION.TOP_CENTER,
				});
				return;
			}
		}
		this.setState({modalRefund: !this.state.modalRefund});
	};

	handleRefundItems = async (refundItems) => {
		const pkey =
			refundItems && refundItems[0] && refundItems[0].transaction
				? refundItems[0].transaction
				: this.props.transaction;
		let model = new API.BuildClass(Types.Transactions_Entries._name, API.RequestType.READ_ALL);
		model.parent = pkey;
		model.limit = 100;
		let items = await model.submit(null, "GET_ALL");
		this.setState({refundItems: items.items});
	}

	handleRefundModalAfterSave = async () => {
		this.setState({modalRefund: false});
		const er = this.transactionEntriesRef.current;
		if (er && typeof er.reloadTable === "function") {
			er.reloadTable();
		}
		const tr = this.transactionRef.current;
		if (tr && typeof tr.loadSelf === "function") {
			await tr.loadSelf();
		}
		this.setState({Tkey: Math.random(), Rkey: Math.random()});
	};

	allItemsAreFree() {
		const { refundItems } = this.state;
		if (refundItems.length === 0) return false;

		const transactionValue = refundItems[0].transactions.amount;
		return transactionValue === "0.00";
	}

	render() {
		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: this.props.transaction,
				url: `/transactions/${this.props.transaction}`,
				icon: 'edit',
			}
		]);

		const shouldHideButton = this.allItemsAreFree();
		const refundable = this.refundableLineItems();
		const showNothingLeftToRefund =
			(this.state.refundItems || []).length > 0 && refundable.length === 0;
		const invoiceAmountDue = this.invoiceAmountDue();
		const showSendInvoice = this.props.rootState.invoicing_enabled
			&& this.props.rootState.pay_by_link_enabled
			&& this.props.rootState.altrupay_linked
			&& invoiceAmountDue > 0;
		const showInvoiceLink = this.state.hasInvoice;

		console.log('TRANSACTION VIEW', this);

		return (
			<>
				<div className="container-fluid">
					<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}>
						<Button size={'sm'} className="primary-button" onClick={this.handlePrintReceipt} disabled={this.state.refundItems.length === 0} block={false}>Print
							Receipt</Button>
						{showSendInvoice &&
							<Button className="primary-button"
								size="sm"
								onClick={this.handleSendInvoice}
								block={false}
							>
								Send Invoice
							</Button>
						}
						<Button size={'sm'} className="secondary-button" onClick={this.handleSendReceipt}>Email Receipt</Button>
						{showInvoiceLink &&
							<Link to={`/invoices/${this.props.transaction}`}>
								<Button size={'sm'} className="secondary-button" block={false}>
									<i className="fa fa-usd"/>&nbsp;&nbsp;To Invoice
								</Button>
							</Link>}
						{!shouldHideButton && <Button size={'sm'} className="primary-button" onClick={this.toggleRefund} block={false}>Refund</Button>}
						<Button size={'sm'} color='danger' className='danger-button' onClick={this.handleDelete}><i className="fa fa-ban"/>&nbsp;&nbsp;Delete</Button>
					</Framework.Components.PageBar>
					{showNothingLeftToRefund ? (
						<Alert color="secondary" className="no-print mb-2">
							All refundable lines on this sale have been fully returned (items, products, and
							consignments). Trade-ins and similar lines are not refunded here. Use{" "}
							<strong>Print receipt</strong> if you need a copy.
						</Alert>
					) : null}
					<Collections.TransactionEntries
						refund={this.handleRefund}
						ref={this.transactionEntriesRef}
						parent={this.props.transaction}
						history={this.props.history}
						account={this.props.account}
						refundItems={this.handleRefundItems}
					/>
					<Card>
						<CardContent>
							<Framework.Errors.General isDev={APPCONFIG.settings.isDev()}>
								<Objects.Transaction
									key={this.state.Tkey}
									ref={this.transactionRef}
									history={this.props.history}
									base={this.props.base}
									account={this.props.account}
									id={this.props.transaction}
									onInvoiceMeta={this.handleInvoiceMeta}
									// shouldSave={this.state["saveModelTransaction"]}
									// attemptedSave={this.resetModal("Transaction")}
								/>
							</Framework.Errors.General>
						</CardContent>
					</Card>
					<Collections.TransactionRefunds
						key={this.state.Rkey}
						parent={this.props.transaction}
						history={this.props.history}
						account={this.props.account}
					/>
					<Framework.Elements.UniversalModal
						isDev={APPCONFIG.settings.isDev()}
						title={"Refund"}
						name={"Refunds"}
						submitLabel={"Refund"}
						parent={this.props.transaction}
						object={Objects.TransactionRefund}
						objectProps={{
							items: structuredClone(this.refundableLineItems()),
						}}
						history={this.props.history}
						toggle={this.state.modalRefund}
						reportClose={this.toggleRefund}
						afterSave={this.handleRefundModalAfterSave}
						size={'lg'}
						hideGoTo={true}
						project={'pos'}
					/>
				</div>
			</>
		)
	}
}

export default Framework.Components.withRootState(TransactionsView);
